import React from 'react';
import styles from './cost-report-group-row.module.scss';
import CostAmountMenuSection from '../cost-amount-menu-section';
import { IntlShape } from 'react-intl';

interface Props {
    employeeName: string;
    totalAmount: number;
    intl: IntlShape;
    onAddNewCostClick?: () => void;
    amountColumnWidth?: number;
}

const CostReportGroupRow: React.FC<Props> = (props) => {
    return (<div className={styles.containerCostReportGroup}>
        <div className={styles.name}>{props.employeeName}</div>
        <div
            className={styles.info}
            style={props.amountColumnWidth ? { width: props.amountColumnWidth } : undefined}>
            <CostAmountMenuSection 
                amount={props.totalAmount}
                intl={props.intl}
                onAddNewCostClick={props.onAddNewCostClick} />
        </div>
    </div>)
}

export default CostReportGroupRow;
